import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalAdditionalQuestionsPageRoutingModule } from './modal-additional-questions-routing.module';

import { ModalAdditionalQuestionsPage } from './modal-additional-questions.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModalAdditionalQuestionsPageRoutingModule
  ],
  declarations: [ModalAdditionalQuestionsPage]
})
export class ModalAdditionalQuestionsPageModule {}
